import { Navigate } from 'react-router';
import { flags } from '@cowoo/shared';
import { useAdminStore } from '../../lib/store';

/**
 * Where `/` goes (10-web-admin § 3).
 *
 * Grundrisse for owner and staff, Zahlen for a viewer. The home is derived from
 * capabilities rather than hard-coded, so it can never point at a screen the
 * role would be bounced out of.
 *
 * A role with nothing to open falls through to `/kein-zugang`. That is not a
 * policy about viewers — the decision of 2026-09-28 is that the role is simply
 * not offered when inviting until Zahlen ships (`06-auth` § 4.2) — it is the
 * guard that keeps an unreachable state from rendering as a blank page.
 */
const HOME: { capability: string; to: string }[] = [
  { capability: 'plans.edit', to: '/grundrisse' },
  { capability: 'bookings.manage', to: '/buchungen' },
  ...(flags.analytics ? [{ capability: 'analytics.read', to: '/zahlen/uebersicht' }] : []),
];

export function Home() {
  const can = useAdminStore((state) => state.can);
  const target = HOME.find((entry) => can(entry.capability))?.to ?? '/kein-zugang';
  return <Navigate to={target} replace />;
}
